import z from "zod";
import {
  AIHealthDetailsDtoSchema,
  AIJobStatusDtoSchema,
} from "../../models/ai.schema";

export const PrivateAIControllerResponseSchema = {
  aiHealthCheck: AIHealthDetailsDtoSchema,

  generateMinutes: z.object({ jobId: z.string() }).nullable(),

  generateMinutesWithAV: z.object({ jobId: z.string() }).nullable(),

  getJobStatus: AIJobStatusDtoSchema.nullable(),

  getJobResult: z
    .object({
      minutes: z.string().optional(),
      error: z.string().optional(),
    })
    .nullable(),

  deleteJob: z.boolean(),
};
